import { summaryData } from '../data/lessonsData';

function ModuleSummary() {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#39FF14] rounded-full mb-4">
          <i className="ri-file-text-line text-3xl text-[#1A3A2E]"></i>
        </div>
        <h1 className="text-3xl font-bold text-[#1A3A2E] mb-4">{summaryData.title}</h1>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Consolidación de los conceptos clave del Módulo 3 y su aplicación práctica inmediata en el diseño de programas de entrenamiento.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-8">
        <div className="bg-gradient-to-br from-[#1A3A2E] to-[#0F2419] rounded-xl p-6">
          <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
            <i className="ri-brain-line text-[#39FF14]"></i>
            Conceptos Dominados
          </h2>
          <ul className="space-y-3">
            {summaryData.concepts.map((concept, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-200">
                <i className="ri-checkbox-circle-fill text-[#39FF14] text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">{concept}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-gradient-to-br from-[#39FF14]/10 to-[#1A3A2E]/10 rounded-xl p-6 border-2 border-[#39FF14]">
          <h2 className="text-xl font-bold text-[#1A3A2E] mb-4 flex items-center gap-2">
            <i className="ri-rocket-line text-[#39FF14]"></i>
            Aplicación Práctica Inmediata
          </h2>
          <ul className="space-y-3">
            {summaryData.application.map((item, index) => (
              <li key={index} className="flex items-start gap-3 text-gray-700">
                <i className="ri-arrow-right-circle-fill text-[#39FF14] text-lg flex-shrink-0 mt-0.5"></i>
                <span className="text-sm leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-[#39FF14]">
        <h3 className="text-lg font-bold text-[#1A3A2E] mb-3 flex items-center gap-2">
          <i className="ri-lightbulb-flash-line text-[#39FF14]"></i>
          Mensaje Clave del Módulo
        </h3>
        <p className="text-gray-700 leading-relaxed">
          No existe "la mejor metodología de entrenamiento". Existe la metodología más adecuada para tu nivel actual, tiempo disponible, capacidad de recuperación y objetivo específico. Un principiante no debe entrenar como un culturista profesional, ni un atleta de fuerza como un bodybuilder. Domina los principios, comprende las diferencias, y selecciona con criterio. La consistencia en una metodología adecuada supera a la búsqueda constante de la metodología perfecta.
        </p>
      </div>

      <div className="mt-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#39FF14]/20 px-4 py-2 rounded-full">
          <i className="ri-medal-line text-[#39FF14]"></i>
          <span className="text-[#1A3A2E] text-sm font-semibold">
            Módulo 3 Completado - Continúa con el Checklist y la Autoevaluación
          </span>
        </div>
      </div>
    </div>
  );
}

export default ModuleSummary;